// A stale session surfaces as 401, or as the tenant middleware's auth-shaped
// 403 ("Authentication required" / "token not valid") once the refresh path has
// given up. Pages must say "session expired", not "couldn't do X" — a wrong
// error message costs a diagnosis every time.
const AUTH_SHAPED = /authentication required|token not valid|token is invalid|token_not_valid|session expired|credentials were not provided/i;
export const isSessionExpired = (err) => {
  const status = Number(err?.status || err?.response?.status || 0);
  const detail = String(err?.payload?.detail || err?.payload?.error || err?.message || "");
  return status === 401 || (status === 403 && AUTH_SHAPED.test(detail));
};

export const SESSION_EXPIRED_MESSAGE = "Your session expired — sign in again to continue.";
